import React from 'react';
import { ModuleSection } from '@/components';
import { ImageModel, ModuleBaseModel, ModuleSectionPropsModel } from '@/types';
import ImageCarouselLandscape from './ImageCarouselLandscape';
import ImageCarouselPortrait from './ImageCarouselPortrait';

type ImageCarouselModel = ModuleBaseModel<
  {
    imageOrientation?: 'Landscape' | 'Portrait';
    images: ImageModel[];
  } & ModuleSectionPropsModel
>;

const ImageCarousel = (data: ImageCarouselModel) => {
  const { imageOrientation, images } = data.props;

  return (
    <ModuleSection
      data={data}
      className="sm:[&_.section-heading]:w-[69%] md:[&_.section-heading]:w-[97%] xl:[&_.section-heading]:w-[87%] [&_.section-heading-container]:flex [&_.section-heading-container]:justify-center"
    >
      {imageOrientation === 'Landscape' ? (
        <ImageCarouselLandscape images={images} />
      ) : (
        <ImageCarouselPortrait images={images} />
      )}
    </ModuleSection>
  );
};

export default ImageCarousel;
